import { CATALOG_SERVICE_URL, QUOTE_SERVICE_URL } from "../../libs/constants";
import app from './app';
import quoteDetails from "./quoteDetails";
import { saveAs } from 'file-saver';

const uploadCustomerFormFile = (requestData, fileName, userId, countryList, initialQuoteType) => async (dispatch, getState, api) => {
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'countryList': countryList.join(","),
            'ctInitialQuoteType': initialQuoteType,
        }
    }
    await api.post(QUOTE_SERVICE_URL + "/file/upload/" + userId, requestData, config)
        .then(response => {
            //;
            if (response.data.quoteId) {
                dispatch(setFileName(fileName));
                dispatch(setQuoteId(response.data.quoteId));
                dispatch(updateQuoteGeneralDataField({
                    name: "quoteNumber", value: response.data.quoteId
                }))
                dispatch(setFileUploadStatusDesc(""));
                dispatch(setFileUploadStatus("success"));
            }
            else {
                dispatch(setQuoteId(""));
                dispatch(setFileUploadStatus("error"));
            }
        })
        .catch(error => {
            dispatch(setQuoteId(""));
            dispatch(setFileUploadStatus("error"));
            dispatch(setFileUploadStatusDesc(error?.response?.data?.message || ''));
        });
};

const uploadHPFormFile = (requestData, fileName, userId, countryList, quoteNumber) => async (dispatch, getState, api) => {

    dispatch(app.setLoading(true));
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'countryList': countryList.join(","),
            'quoteNumber': quoteNumber,
            'hprevitalizeStatus': 'true'
        }
    }

    await api.post(QUOTE_SERVICE_URL + "/hpFile/upload/" + userId + "/" + quoteNumber, requestData, config)
        .then(response => {
            if (response.data === 'File upload Successfully') {
                dispatch(setHPFileName(fileName));
                dispatch(setHPFileUploadStatus("success"));
                dispatch(quoteDetails.getCTInitialQuoteDetail(userId, quoteNumber));
            }
            else {
                dispatch(setHPFileUploadStatus("error"));
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(setHPFileUploadStatus("error"));
            dispatch(app.setLoading(false));
        });
};

const downloadExcel = (userId, quoteId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let apiEndPointUrl = QUOTE_SERVICE_URL + `/downloadExcel/${userId}/${quoteId}`;
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };
    await api.post(apiEndPointUrl, null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), `CTQuote_${quoteId}_CustomerVersion.xlsx`);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const downloadHPQuoteTemplate = (userId, quoteId) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            "DRS-Fetch-Type": "downloadHPQuoteForm"
        },
        responseType: "blob"
    };

    await api.post(QUOTE_SERVICE_URL + '/download/hpPriceTemplate/' + userId + "/" + quoteId, null, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), `HP_quote_Template.xlsx`);
        });
}

const getVendors = (requestData, userId) => async (dispatch, getState, api) => {
    const headerConfig = { headers: { "DRS-Fetch-Type": "getVendors" } };
    await api.post(CATALOG_SERVICE_URL + "countries/vendors/" + userId, requestData, headerConfig)
        .then(response => {
            if (response.data.vendorHeaders && response.data.countryVendors) {
                dispatch(setVendorList(response.data.vendorHeaders));
                dispatch(setVendorSelectionData(response.data, true, true));
            }
            else {
                dispatch(setVendorList([]));
                dispatch(setVendorSelectionData({ vendorHeaders: [], countryVendors: [] }, true, true));
            }
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getRevitalizeVendors = (requestData, userId) => async (dispatch, getState, api) => {
    const headerConfig = { headers: { "DRS-Fetch-Type": "getRevitalizeVendors" } };
    requestData.requestorType = requestData.requestorType || "direct";
    await api.post(CATALOG_SERVICE_URL + "countries/vendors/" + userId, requestData, headerConfig)
        .then(response => {
            if (response.data.vendorHeaders && response.data.countryVendors) {
                dispatch(setRevitalizeVendors(response.data));
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getPriceLists = () => async (dispatch, getState, api) => {
    await api.post(CATALOG_SERVICE_URL + "priceList/HardwareAndService", {})
        .then(response => {
            if (response.data.priceList) {
                dispatch({
                    type: "SET_DIRECT_QUOTE_FIELD",
                    data: { id: "priceLists", value: response.data.priceList }
                })
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getServicePriceLists = () => async (dispatch, getState, api) => {
    await api.post(CATALOG_SERVICE_URL + "priceList/Service", {})
        .then(response => {
            if (response.data.priceList) {
                dispatch({
                    type: "SET_DIRECT_QUOTE_FIELD",
                    data: { id: "servicePriceLists", value: response.data.priceList }
                })
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const sendQuoteMail = (userId, requestObj) => async (dispatch, getState, api) => {
    await api.post(QUOTE_SERVICE_URL + "/send/email/" + userId, requestObj)
        .then(response => {
            if (response.data) {
                dispatch(app.setAppModal({ type: "info", messageId: "quote_email_success" }));
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getHPMargins = (requestData, userId) => async (dispatch, getState, api) => {
    try {
        const response = await api.post(QUOTE_SERVICE_URL + '/hpmargins/' + userId, requestData);
        if (response.data.costMarginsResponses) {
            const marginData = response.data.costMarginsResponses;
            const marginCombinedData = [
                ...(marginData["payment1.1"] || []),
                ...(marginData["payment1.0"] || [])
            ];

            if (marginData.hasOwnProperty("payment1.1") || marginData.hasOwnProperty("payment1.0")) {
                dispatch({
                    type: "UPDATE_PAYMENT_ONE_POINT_ONE_DEFAULT_MARGINS",
                    data: marginCombinedData
                });
            } else {
                dispatch(resetPaymentOnePointOneDefaultMargins());
            }

            // if (marginData.hasOwnProperty("payment1.0")) {
            //     dispatch({
            //         type: "UPDATE_PAYMENT_ONE_POINT_O_DEFAULT_MARGINS",
            //         data: marginData["payment1.0"]
            //     });
            // }
            // else {
            //     dispatch(resetPaymentOnePointODefaultMargins());
            // }
        }
    } catch (error) {
        //
    }
};

const setVendorSelectionData = (vendorData, needsTransformation, constructVendorDataCopy) => {
    return {
        type: 'SET_VENDOR_DATA',
        data: { vendorData, needsTransformation, constructVendorDataCopy }
    }
}

const setInitialQuoteType = (initialQuoteType) => {
    return {
        type: 'SET_INITIAL_QUOTE_TYPE',
        data: { initialQuoteType }
    }
}

const setInternalHPComment = (internalHPComments) => {
    return {
        type: 'SET_INTERNAL_HP_COMMENT',
        data: { internalHPComments }
    }
}

const setRevitalizeVendors = (countries) => {
    let revitalizeVendors = []
    countries.countryVendors.map(country => {
        let obj = {}
        obj.country = country.countryCode;
        obj.vendors = [];
        country.vendors.map(vendor => {
            if (vendor.revitalize) {
                obj.vendors.push(vendor.vendorName);
            }
        })
        if (obj.vendors.length) {
            revitalizeVendors.push(obj)
        }
    })
    console.log(revitalizeVendors)
    return {
        type: 'SET_REVITALIZE_VENDOR',
        data: revitalizeVendors
    }
}

const setVendorList = (vendorList) => {
    return {
        type: 'SET_VENDOR_LIST',
        data: vendorList
    }
}

const checkForFileUploadError = (errorMessage = '') => {
    const errorMessageList = ['The specified key does not exist', 'FIELD_EMPTY', 'COLUMN_MISSING', 'FILE_EMPTY', 'INCORRECT_COUNTRY'];
    for (let i = 0; i < errorMessageList.length; i++) {
        if (errorMessage.includes(errorMessageList[i])) {
            return true;
        }
    }
    return false;
}

const generateDirectQuote = (requestData, callback) => async (dispatch, getState, api) => {
    console.log(requestData, "generateQuote");
    dispatch(app.setLoading(true));
    await api.post(QUOTE_SERVICE_URL + '/direct/generateQuote', requestData)
        .then(response => {
            dispatch(app.setLoading(false));
            dispatch({
                type: "SET_NEW_DIRECT_QUOTE_CREATED",
                data: response.data
            });
            callback && callback();
        })
        .catch(error => {
            if (error && error.response && error.response.data && error.response.data.message && checkForFileUploadError(error.response.data.message)) {
                dispatch(setFileName(''));
                dispatch(setFileUploadStatus(false));
            }
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//POST
const saveDirectQuote = requestData => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(QUOTE_SERVICE_URL + '/direct/saveQuote', requestData)
        .then(response => {
            dispatch(app.setLoading(false));
            if (response.data.status) {
                dispatch({
                    type: "SET_NEW_DIRECT_QUOTE_SAVED",
                    data: requestData.action
                });
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const requestPrices = (requestData, callback) => async (dispatch, getState, api) => {
    console.log(requestData, "requestQuote");
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getDirectCustomerQuoteDetails" } };
        await api.post('/quote/direct/requestQuote', requestData, headerConfig);

        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "info", messageId: "request_prices_success" }));
        callback && callback();
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getDropdownOptions = (dropdownType) => async (dispatch, getState, api) => {
    const headerConfig = { headers: { "DRS-Fetch-Type": `get_${dropdownType}` } };
    try {
        const response = await api.get(`/catalog/getConfigListByKey/${dropdownType}`, {}, headerConfig);
        if (dropdownType === 'quote_request_type') {
            dispatch({ type: "SET_QUOTE_REQUEST_TYPE_OPTIONS", data: response.data });
        }
        if (dropdownType === 'quote_lead_origin') {
            dispatch({ type: "SET_LEAD_ORIGIN_OPTIONS", data: response.data });
        }
        if (dropdownType === 'quote_lead_source') {
            dispatch({ type: "SET_LEAD_SOURCE_OPTIONS", data: response.data });
        }
        if (dropdownType === 'quote_rejection_reason') {
            dispatch({ type: "SET_REJECTION_REASON_OPTIONS", data: response.data });
        }
        if (dropdownType === 'enable_unified_capabilities') {
            dispatch({ type: "SET_ENABLE_UNIFIED_CAPABILITIES", data: response.data });
        }
    } catch (error) {
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getConfigValueByKey = (key) => async (dispatch, getState, api) => {
    const headerConfig = { headers: { "DRS-Fetch-Type": `get_${key}` } };
    try {
        const response = await api.get(`/catalog/getConfigValueByKey/${key}`, {}, headerConfig);
        if (key === 'enable_unified_capabilities') {
            dispatch({ type: "SET_ENABLE_UNIFIED_CAPABILITIES", data: response.data });
        }
    } catch (error) {
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const resetPaymentOnePointOneDefaultMargins = () => {
    return {
        type: 'RESET_PAYMENT_ONE_POINT_ONE_DEFAULT_MARGINS',
        data: []
    }
}

const resetPaymentOnePointODefaultMargins = () => {
    return {
        type: 'RESET_PAYMENT_ONE_POINT_O_DEFAULT_MARGINS',
        data: []
    }
}

const updateQuoteGeneralDataField = fieldData => {
    return {
        type: 'UPDATE_QUOTE_GENERAL_DATA_FIELD',
        data: fieldData
    }
}

const updatePaymentOnePointOneMarginData = marginData => {
    return {
        type: 'UPDATE_PAYMENT_ONE_POINT_ONE_MARGIN_DATA',
        data: marginData
    }
}

const updatePaymentOnePointOMarginData = marginData => {
    return {
        type: 'UPDATE_PAYMENT_ONE_POINT_O_MARGIN_DATA',
        data: marginData
    }
}

const updateCountryList = countryList => {
    return {
        type: 'UPDATE_COUNTRY_LIST',
        data: countryList
    }
}

const setQuoteId = quoteId => {
    return {
        type: "SET_QUOTE_ID",
        data: quoteId
    }
}
const setFileUploadStatus = status => {
    return {
        type: "SET_FILE_UPLOAD_STATUS",
        data: status
    }
}
const setFileUploadStatusDesc = status => {
    return {
        type: "SET_FILE_UPLOAD_STATUS_DESC",
        data: status
    }
}
const setHPFileUploadStatus = status => {
    return {
        type: "SET_HP_FILE_UPLOAD_STATUS",
        data: status
    }
}
const setVendorSelection = option => {
    return {
        type: "SET_VENDOR_SELECTION",
        data: option
    }
}
const setRateCardSelection = option => {
    return {
        type: "SET_RATE_CARD_SELECTION",
        data: option
    }
}
const setRateConversionSelection = option => {
    return {
        type: "SET_RATE_CONVERSION_SELECTION",
        data: option
    }
}
const setVendorMatrixSelections = vendorData => {
    return {
        type: "SET_VENDOR_MATRIX_SELECTIONS",
        data: vendorData
    }
}
const setVendorNetValues = netValues => {
    return {
        type: "SET_VENDOR_NET_VALUES",
        data: netValues
    }
}
const setUserSelectedVendor = vendorName => {
    return {
        type: "SET_USER_SELECTED_VENDOR",
        data: vendorName
    }
}
const setDirectQuoteField = (id, value) => {
    return {
        type: "SET_DIRECT_QUOTE_FIELD",
        data: { id, value }
    }
}
const updateTableData = data => {
    return {
        type: "UPDATE_TABLE_DATA",
        data: data
    }
}
const resetQuoteData = () => {
    return {
        type: "RESET_QUOTE_DATA"
    }
}

const backButtonStatus = (status) => {
    return {
        type: "BACK_BUTTON_CLICKED",
        data: status
    }
}

const setFileName = fileName => {
    return {
        type: "SET_FILE_NAME",
        data: fileName
    }
}

const setHPFileName = fileName => {
    return {
        type: "SET_HP_FILE_NAME",
        data: fileName
    }
}

const setVendorError = (message) => {
    return {
        type: "SET_VENDOR_ERROR",
        data: message
    }
}
const setCountryError = (message) => {
    return {
        type: "SET_COUNTRY_ERROR",
        data: message
    }
}

const setConvertedVendorNetValues = netValues => {
    return {
        type: "SET_CONVERTED_VENDOR_NET_VALUES",
        data: netValues
    }
}

const setUserSelectedTotalVendorNetValue = userSelectedTotalVendorNetValue => {
    return {
        type: "SET_USER_SELECTED_TOTAL_VENDOR_NET_VALUE",
        data: userSelectedTotalVendorNetValue
    }
}

const setMaxNetValue = maxNetValue => {
    return {
        type: "SET_MAX_NET_VALUE",
        data: maxNetValue
    }
}

const directCustomerQuoteActions = {
    uploadCustomerFormFile,
    uploadHPFormFile,
    setFileName,
    setQuoteId,
    setFileUploadStatus,
    setFileUploadStatusDesc,
    setHPFileUploadStatus,
    setVendorSelection,
    setRateCardSelection,
    setRateConversionSelection,
    updateQuoteGeneralDataField,
    updatePaymentOnePointOneMarginData,
    updatePaymentOnePointOMarginData,
    getHPMargins,
    updateCountryList,
    resetPaymentOnePointOneDefaultMargins,
    resetPaymentOnePointODefaultMargins,
    generateDirectQuote,
    getVendors,
    setVendorSelectionData,
    setVendorList,
    setVendorMatrixSelections,
    setVendorNetValues,
    setUserSelectedVendor,
    setInternalHPComment,
    getPriceLists,
    setDirectQuoteField,
    saveDirectQuote,
    resetQuoteData,
    setInitialQuoteType,
    setRevitalizeVendors,
    sendQuoteMail,
    updateTableData,
    downloadExcel,
    backButtonStatus,
    setVendorError,
    setCountryError,
    requestPrices,
    setConvertedVendorNetValues,
    setUserSelectedTotalVendorNetValue,
    setMaxNetValue,
    getServicePriceLists,
    downloadHPQuoteTemplate,
    getRevitalizeVendors,
    getDropdownOptions,
    getConfigValueByKey
}

export default directCustomerQuoteActions;